import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-managment-main',
  templateUrl: './user-managment-main.component.html',
  styleUrls: ['./user-managment-main.component.scss']
})
export class UserManagmentMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-managment-main/user-managment-main.component.ts